var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYii(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -222.9086,
    y1: 274.7419,
    x2: -222.9086,
    y2: 274.5637,
    gradientTransform: "matrix(92.2818 0 0 -178.5439 20610.4648 49054.1211)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73B723"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8EE61"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.3,0.6c3.3,1.7,6.2,6.1,6,12.1c-0.4,7.4-5.8,13.8-11.7,19.7c-0.3-7.2-1.9-11.7-4.3-18.2 C30,7.8,36.7,0.8,42.3,0.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -222.2446,
    y1: 275.1404,
    x2: -222.3716,
    y2: 275.009,
    gradientTransform: "matrix(93.816 0 0 -129.8399 20882.584 35755.457)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98C9EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6886,
    style: {
      stopColor: "#026FB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#086EB6"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.3,32.2c1.8-2.2,3-4.2,3.9-6c6,3.2,4.6,2.6,7.5,5.9c0,0.1,0,0.2,0,0.3c0.2,4.7-3.2,15.4-16.5,16.9 C18.3,42.1,21.4,36,24.3,32.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -222.5484,
    y1: 274.3517,
    x2: -222.3954,
    y2: 274.2383,
    gradientTransform: "matrix(156.0025 0 0 -128.7695 34720.6875 35333.4688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D73721"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7D768"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.8,5.1c9.5-3.8,19.8,0.1,25.7,8.1c0.6,0.8,1.1,1.6,1.6,2.4c0.9,5.9,0.2,9.2-1.6,10.9 c-1.2-0.6-2.4-1.1-3.8-1.6c-3.1-1.1-6-1.9-10.2-3.1C4.8,19.2,2.4,10.8,2.8,5.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -221.4077,
    y1: 274.3058,
    x2: -221.3082,
    y2: 274.2153,
    gradientTransform: "matrix(42.8774 0 0 -97.3628 9523.2256 26729.418)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4C883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A1D1A7"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.8,15.1c0.1,0.1,0.1,0.2,0.2,0.3l0.1,0.1c0.2,0.2,0.3,0.5,0.5,0.7l0,0l0,0.1l0,0.1l0.1,0.2l0,0l0.1,0.3l0,0 c0.1,0.2,0.2,0.4,0.3,0.6l0,0l0.1,0.2l0,0l0.1,0.2l0,0.1l0.1,0.1l0.1,0.2l0.1,0.2c0.1,0.2,0.2,0.3,0.2,0.5l0,0 c0.1,0.3,0.3,0.6,0.4,0.9l0.1,0.2l0,0l0.1,0.1l0.1,0.2l0,0.1l0.1,0.2l0.1,0.1l0.1,0.3l0,0l0.1,0.3l0,0c0.1,0.3,0.2,0.6,0.4,0.9l0,0 l0.1,0.2l0,0l0.1,0.1c0.1,0.2,0.1,0.3,0.2,0.5l0,0.1c0.1,0.2,0.1,0.4,0.2,0.6l0,0.1c0.1,0.2,0.1,0.3,0.2,0.5l0,0.1l0,0l0.1,0.3l0,0 l0.1,0.3l0.1,0.3l0,0l0.1,0.2l0,0.1l0,0.1c0,0.2,0.1,0.3,0.1,0.5l0,0.1l0.1,0.2l0,0c0.1,0.3,0.2,0.6,0.2,0.9l0,0l0,0 c0.1,0.4,0.2,0.8,0.3,1.2l0,0c0.1,0.6,0.2,1.2,0.3,1.8l0,0c0,0.2,0.1,0.4,0.1,0.6l0,0.1l0,0.3v0l0,0.2l0,0.1l0,0.2l0,0.1l0,0l0,0.3 c-2.1-2.7-4.6-4.6-7.6-6C30.6,21.6,30.3,18.2,29.8,15.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYii);
export default __webpack_public_path__ + "static/media/yii.c88d5c2ae44fc5a179692a6c717512af.svg";
export { ForwardRef as ReactComponent };